// // Uncomment to test locally

// const searchContainer = document.getElementById('search');

// // SIMULATE Matrix query string
// var currentURL = window.location.href;
// var query_string = currentURL.split('?')[1];

// if (!query_string) {
//   query_string = '&query=!showall';
// } else if (!query_string.includes('query=')) {
//   query_string += '&query=!showall';
// }

// // Running only is searchContainer exists (it will not exist in prod)
// if (searchContainer) {
//   fetch(
//     `https://dxp-uk-search.funnelback.squiz.cloud/s/search.json?collection=maug~sp-mauve&profile=mauve-search_preview&${query_string}`
//   )
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       return response.json();
//     })
//     .then((data) => {
//       buildSearchHtml(data);

//       searchLogic();
//     })
//     .catch((error) => {
//       console.error('There was a problem with the fetch operation:', error);
//     });
// }

// //
// // HTML templating - start moved to file in Matrix
// //
// let html = '';

// const buildSearchBannerHtml = (fbResponse) => {
//   // Metadata

//   const query = fbResponse.response.resultPacket.query;
//   let tempHtml = `<!-- Search Banner - start-->
//         <section class="search-banner">
//             <div class="search-banner__container container">
//                 <div class="search-banner__content">
//                     <div class="breadcrumbs">
//                         <div class="breadcrumbs__wrapper">
//                             <nav class="breadcrumbs__nav" aria-label="Breadcrumbs">
//                                 <ul class="breadcrumbs__list">
//                                     <li class="breadcrumbs__item">
//                                     <a class="breadcrumbs__link" href="#">
//                                         <span class="sr-only">Go to Home Page</span>
//                                     </a>
//                                     </li>
//                                     <li class="breadcrumbs__item">
//                                     <span class="breadcrumbs__link" aria-current="page"
//                                         >Search</span
//                                     >
//                                     </li>
//                                 </ul>
//                             </nav>
//                         </div>
//                     </div>
//                     <div class="search-banner__text-wrapper">
//                         <h1 class="search-banner__title">Search Results</h1>
//                         <p class="search-banner__description">
//                             The latest industry news, interviews, technologies, and resources.
//                         </p>
//                     </div>
//                     <div class="search-banner__search-wrapper">
//                         <form id="searchForm">
//                             <input
//                                 type="text"
//                                 name="query"
//                                 id="queryInput"
//                                 value="${query !== '!showall' ? query : ''}"
//                                 placeholder="Search category or content..."
//                                             />
//                             <input type="submit" value="Search" />
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </section>
//         <!-- Search Banner - end-->`;
//   return tempHtml;
// };

// const buildFacetsList = (facets) => {
//   let tempHtml = '';

//   facets.forEach((facet) => {
//     if (facet.allValues.length !== 0) {
//       tempHtml += `<fieldset
//       class="search-filters__fieldset"
//       aria-labelledby="${transformString(facet.name)}-title"
//     >
//             <div id="${transformString(
//               facet.name
//             )}-title" class="search-filters__title">${facet.name}</div>
//             <ul class="search-filters__category-list">`;

//       facet.allValues.forEach((value) => {
//         // UPDATE TOGGLE URL
//         const updatedPath = stripFacetToggleUrl(value.toggleUrl);

//         tempHtml += `<li class="search-filters__category-item">
//                             <input
//                                 type="checkbox"
//                                 name="${transformString(facet.name)}"
//                                 class="category-checkbox"
//                                 id="${transformString(value.data)}"
//                                 data-toggle-url="${updatedPath}"
//                                 ${value.selected ? 'checked' : ''}
//                             />
//                             <label tabindex="0" for="${transformString(
//                               value.data
//                             )}" class="category-checkbox__label">${
//           value.label
//         } <span>${value.selected ? '' : '(' + value.count + ')'}</span></label>
//                         </li>`;
//       });
//       tempHtml += `</ul>
//                     </fieldset>`;
//     }
//   });
//   return tempHtml;
// };

// const buildFacetsMobile = (fbResponse) => {
//   const facets = fbResponse.response.facets;
//   const clearAll = fbResponse.response.facetExtras.unselectAllFacetsUrl;
//   const hasSelectedNonTabFacets =
//     fbResponse.response.facetExtras.hasSelectedNonTabFacets;

//   // UPDATE Clear All URL
//   const updatedClearAll = stripFacetToggleUrl(clearAll);

//   let tempHtml = '';

//   tempHtml += `<!-- Search Mobile Facets - start -->
//                     <div class="search-filters__category-mobile">
//                         <form class="search-filters__form">`;

//   tempHtml += buildFacetsList(facets);

//   if (hasSelectedNonTabFacets) {
//     tempHtml += `<a href="${updatedClearAll}" class="button button-clearall"> &#x2715; Clear all </a>`;
//   }

//   tempHtml += `</form>
//           </div>
//         <!-- Search Mobile Facets - start -->`;

//   return tempHtml;
// };

// const buildFiltersHtml = (fbResponse) => {
//   const sortSelected = fbResponse.question.inputParameters.sort;
//   const facets = fbResponse.response.facets;
//   const clearAll = fbResponse.response.facetExtras.unselectAllFacetsUrl;
//   const hasSelectedNonTabFacets =
//     fbResponse.response.facetExtras.hasSelectedNonTabFacets;

//   // UPDATE Clear All URL
//   const updatedClearAll = stripFacetToggleUrl(clearAll);

//   let tempHtml = `<!-- Search Filters - start -->
//                       <div class="search-filters">
//                           <div class="search-filters__wrapper">
//                           <form class="search-filters__form" id="sortFilterBy">
//                               <div class="search-filters__sorting-wrapper">
//                                   <select
//                                       name="sort"
//                                       id="sortSelect"
//                                       class="sq-form-field search-filters__sorting-order"
//                                       aria-label="Sort by"
//                                   >
//                                       <option value="" ${
//                                         !sortSelected ? 'selected' : ''
//                                       }>Relevance</option>
//                                       <option value="date" ${
//                                         sortSelected == 'date' ? 'selected' : ''
//                                       }>Newest First</option>
//                                       <option value="adate" ${
//                                         sortSelected == 'adate'
//                                           ? 'selected'
//                                           : ''
//                                       }>Oldest First</option>
//                                       <option value="title" ${
//                                         sortSelected == 'title'
//                                           ? 'selected'
//                                           : ''
//                                       }>Alphabetical order</option>
//                                   </select>
//                               </div>
//                               `;

//   tempHtml += `<div class="search-filters__category-desktop">`;
//   tempHtml += buildFacetsList(facets);

//   if (hasSelectedNonTabFacets) {
//     tempHtml += `<a href="${updatedClearAll}" class="button button-clearall"> &#x2715; Clear all </a>`;
//   }
//   tempHtml += `</div>`;

//   tempHtml += `   </form>
//                   </div>
//               </div>
//               <!-- Search Filters - end -->`;
//   return tempHtml;
// };

// const buildSearchPagination = (fbResponse) => {
//   // Variables from FB response
//   const totalResults =
//     fbResponse.response.resultPacket.resultsSummary.totalMatching;
//   const resultsPerPage =
//     fbResponse.response.resultPacket.resultsSummary.numRanks;
//   const start_rank = fbResponse.response.resultPacket.resultsSummary.currStart;
//   const prevStart = fbResponse.response.resultPacket.resultsSummary.prevStart;
//   const nextStart = fbResponse.response.resultPacket.resultsSummary.nextStart;

//   // Variables
//   const currentPage = (start_rank - 1) / resultsPerPage + 1;
//   const totalPages = Math.ceil(totalResults / resultsPerPage);

//   let tempHtml = `<!-- Pagination - start -->
//   <div class="pagination">
//     <div class="pagination__link">
//       <a
//         href="#"
//         class="button button-secondary button-arrow button-arrow--left ${
//           currentPage === 1 ? 'button-disabled' : ''
//         }"
//         id="prevButton"
//         title="Previous Page"
//         data-start-rank="${prevStart}"
//       >
//         <span class="button-text">Previous</span>
//       </a>
//     </div>
//     <ul class="pagination__list">`;

//   // Generate the pagination buttons
//   let startPage = 1;
//   let endPage = totalPages;

//   if (totalPages > 5) {
//     startPage = currentPage - 2;
//     if (startPage < 1) {
//       startPage = 1;
//     }

//     endPage = startPage + 4;
//     if (endPage > totalPages) {
//       endPage = totalPages;
//       startPage = endPage - 4;
//     }
//   }

//   for (let i = startPage; i <= endPage; i++) {
//     tempHtml += `<li class="pagination__item">
//                     <a class="pagination__list-link ${
//                       i === currentPage ? 'active' : ''
//                     }" ${
//       i === currentPage ? 'aria-current="page"' : ''
//     } data-start-rank="${
//       start_rank - resultsPerPage * (currentPage - i)
//     }" href="#">${i}</a></li>`;
//   }
//   //

//   tempHtml += `</ul>
//     <div class="pagination__list-mobile">
//       <p>
//         Page <span class="number">${currentPage}</span> of
//         <span class="number">${totalPages}</span>
//       </p>
//     </div>
//     <div class="pagination__link">
//       <a
//         href="#"
//         id="nextButton"
//         class="button button-secondary button-arrow button-arrow--right ${
//           currentPage === totalPages ? 'button-disabled' : ''
//         }"
//         title="Next Page"
//         data-start-rank="${nextStart}"
//       >
//         <span class="button-text">Next</span>
//       </a>
//     </div>
//   </div>
//   <!-- Pagination - end -->`;

//   return tempHtml;
// };

// const buildSearchResultsHtml = (fbResponse) => {
//   const results = fbResponse.response.resultPacket.results;
//   const totalResults =
//     fbResponse.response.resultPacket.resultsSummary.totalMatching;
//   const currStart = fbResponse.response.resultPacket.resultsSummary.currStart;
//   const currEnd = fbResponse.response.resultPacket.resultsSummary.currEnd;
//   const query = fbResponse.response.resultPacket.query;

//   let tempHtml = `<!-- Search Results - start -->
//                     <section class="search-results">
//                     <div class="search-results__container container">
//                         <div class="search-results__wrapper">`;

//   tempHtml += buildFiltersHtml(fbResponse);

//   // Results list
//   tempHtml += `<div class="search-results__list">`;

//   if (results.length === 0) {
//     tempHtml += `<div class="search-item__not-found">
//                     <span class="search-item__not-found-icon"></span>
//                     <h3 class="search-item__not-found-title">No results found</h3>
//                     <p class="search-item__not-found-text">
//                     We couldn't find any results matching your search. Please try
//                     again.
//                     </p>
//                     <p class="search-item__not-found-link-text">
//                     Did you mean
//                     <a href="#" class="search-item__not-found-link read-more__link"
//                         >Lorem impsum?</a
//                     >
//                     </p>
//                 </div>`;
//   } else {
//     tempHtml += `<p class="search-results__list-count">
//                     <span>${currStart}</span> - <span>${currEnd}</span> of <span>${totalResults}</span> search results for <span><em>"${query}"</em></span>
//                 </p>`;
//     results.forEach((result) => {
//       const image = result.listMetadata.image;
//       const imageAlt = result.listMetadata.imageAlt;
//       const pageType = result.listMetadata.pageType;
//       const date = result.listMetadata.d;
//       const contributors = result.listMetadata.newsContributors;

//       // Result Item
//       tempHtml += `<article class="search-item">
//                 <div class="search-item__image-wrapper">
//                     <img
//                       src="${
//                         image
//                           ? image
//                           : 'https://mauve-dedicated.squiz.cloud/__data/assets/image/0010/5140/varieties/w592.png'
//                       }"
//                       alt="${imageAlt}"
//                       class="search-item__image"
//                     />
//                   <div class="search-item__details">
//                     <div class="search-item__details-left">
//                       <div class="search-item__author">
//                         ${contributors ? formatContributors(contributors) : ''}
//                       </div>
//                       <div class="search-item__date">${
//                         date ? formatDate(date) : ''
//                       }</div>
//                     </div>
//                     <div class="search-item__category">${
//                       pageType ? pageType : ''
//                     }</div>
//                   </div>
//                 </div>
//                 <div class="search-item__content">
//                 <a href="${
//                   result.liveUrl
//                 }" class="search-item__title-link stretched-link">
//                     ${result.title}</a>
//                   <p class="search-item__text">
//                     ${result.summary}
//                   </p>
//                 </div>
//               </article>`;
//     });
//   }

//   tempHtml += `</div>`;
//   // Results list - end

//   // Pagination
//   tempHtml += buildSearchPagination(fbResponse);

//   //Mobile facets
//   tempHtml += buildFacetsMobile(fbResponse);

//   tempHtml += `</div>
//                </div>
//             </section>
//             <!-- Search Results - end -->`;

//   return tempHtml;
// };

// const buildSearchHtml = (fbResponse) => {
//   // Search Banner
//   html += buildSearchBannerHtml(fbResponse);

//   // Search Results
//   html += buildSearchResultsHtml(fbResponse);

//   // Only in dev
//   searchContainer.innerHTML = html;
// };

// // Tools
// const stripFacetToggleUrl = (originalUrl) => {
//   // Split the path into two parts: before the query string and after the query string
//   const queryString = originalUrl.split('?')[1];
//   // Split the query string into individual parameters
//   const parameters = queryString.split('&');

//   // Filter out the 'profile' and 'collection' parameters
//   const filteredParameters = parameters.filter((param) => {
//     const [key] = param.split('=');
//     return key !== 'profile' && key !== 'collection';
//   });

//   // Reconstruct the updated path
//   const updatedPath = '?' + filteredParameters.join('&');

//   return updatedPath;
// };

// const formatDate = (msDate) => {
//   // Create a new Date object using the MS date
//   var date = new Date(msDate);

//   // Define an array of month names
//   var monthNames = [
//     'Jan',
//     'Feb',
//     'Mar',
//     'Apr',
//     'May',
//     'Jun',
//     'Jul',
//     'Aug',
//     'Sep',
//     'Oct',
//     'Nov',
//     'Dec',
//   ];

//   // Extract the desired date components
//   var day = date.getDate();
//   var monthIndex = date.getMonth();
//   var year = date.getFullYear();

//   // Construct the readable date string
//   var readableDate = day + ' ' + monthNames[monthIndex] + ' ' + year;

//   return readableDate;
// };

// const formatContributors = (contributors) => {
//   // Format contributors
//   let authors = '';
//   let isFirstItem = true;

//   contributors.forEach((contributor) => {
//     if (isFirstItem) {
//       authors += contributor;
//       isFirstItem = false;
//     } else {
//       authors += ', ' + contributor;
//     }
//   });
//   return authors;
// };

// // Transform to lowercase and replace spaces with -
// function transformString(str) {
//   // Convert the string to lowercase
//   str = str.toLowerCase();

//   // Replace spaces with hyphens
//   str = str.replace(/\s+/g, '-');

//   return str;
// }

// //
// // HTML templating -  end
// //

// const searchLogic = () => {
//   const queryForm = document.querySelector('#searchForm');
//   const sortSelect = document.querySelector('#sortSelect');
//   const pageLinks = document.querySelectorAll('.pagination__list-link');
//   const prevButton = document.querySelector('#prevButton');
//   const nextButton = document.querySelector('#nextButton');
//   const facets = document.querySelectorAll('.category-checkbox');
//   const facetLabels = document.querySelectorAll('.category-checkbox__label');

//   const currentURL = window.location.href;
//   const query_string = currentURL.split('?')[1];
//   const webPath = currentURL.split('?')[0];

//   // Create an object to store the parameters
//   let params = {};

//   // Populate the Array with the current parameters
//   if (query_string) {
//     // Split the query string into an array of parameter-value pairs
//     const paramsArray = query_string.split('&');

//     // Iterate over the array and extract parameter names and values
//     paramsArray.forEach((param) => {
//       const [name, value] = param.split('=');
//       params[name] = value;
//     });
//   }

//   // Query Events
//   if (queryForm) {
//     queryForm.addEventListener('submit', (event) => {
//       event.preventDefault();

//       var inputValue = document.querySelector('#queryInput').value;

//       params = {
//         query: inputValue,
//       };

//       reloadPage(params);
//     });
//   }

//   // Sort Events
//   if (sortSelect) {
//     sortSelect.addEventListener('change', () => {
//       params.sort = sortSelect.value;

//       reloadPage(params);
//     });
//   }

//   // Pagination Events
//   if (pageLinks) {
//     pageLinks.forEach((pageLink) => {
//       pageLink.addEventListener('click', (event) => {
//         event.preventDefault();

//         const value = event.target.getAttribute('data-start-rank');

//         params.start_rank = value;
//         reloadPage(params);
//       });
//     });
//   }

//   if (prevButton) {
//     prevButton.addEventListener('click', (event) => {
//       event.preventDefault();

//       const value = event.target.getAttribute('data-start-rank');

//       params.start_rank = value;
//       reloadPage(params);
//     });
//   }

//   if (nextButton) {
//     nextButton.addEventListener('click', (event) => {
//       event.preventDefault();

//       const value = event.target.getAttribute('data-start-rank');

//       params.start_rank = value;
//       reloadPage(params);
//     });
//   }

//   // Facets Events
//   if (facets) {
//     facets.forEach((facet) => {
//       facet.addEventListener('change', function (event) {
//         event.preventDefault();
//         const toggleUrl = event.target.getAttribute('data-toggle-url');
//         window.location.href = webPath + toggleUrl;
//       });
//     });
//   }
//   // Keyboard Event
//   if (facetLabels) {
//     facetLabels.forEach(function (label) {
//       label.addEventListener('keydown', function (event) {
//         // Check if the key pressed is the "Enter" key (key code 13) or the spacebar (key code 32)
//         if (event.keyCode === 13 || event.keyCode === 32) {
//           const checkboxId = label.getAttribute('for');
//           const checkbox = document.getElementById(checkboxId);

//           checkbox.checked = !checkbox.checked;
//           const toggleUrl = checkbox.getAttribute('data-toggle-url');
//           window.location.href = webPath + toggleUrl;
//           event.preventDefault(); // Prevent the default behavior of the spacebar key
//         }
//       });
//     });
//   }

//   const reloadPage = (params) => {
//     var newQueryString = '';

//     let isFirstIteration = true;

//     Object.keys(params).forEach((key) => {
//       var value = params[key];
//       if (value) {
//         if (isFirstIteration) {
//           newQueryString += key + '=' + value;
//           isFirstIteration = false; // Set the flag to false for subsequent iterations
//         } else {
//           newQueryString += '&' + key + '=' + value;
//         }
//       }
//     });

//     var newURL = webPath + '?' + newQueryString;

//     // Reload the page with the modified URL
//     window.location.href = newURL;
//   };
// };
